import React, { useEffect } from 'react'

import { useStore } from 'laco-react'
import ClubStore from 'Store/clubs'
import { DataContainer, Row } from 'Components/shared/Container'
import { H2, Text } from 'Components/shared/Typography'
import Input from 'Components/shared/Input'

import styled from '@emotion/styled'
import { Flex } from 'lese'

const InputContainer = styled(Flex)`
  grid-column: 1;
  margin: 16px;
  max-height: 5em;
  align-self: center;
  width: 66%;
`

export default ({ club, setSelectedClub }) => {
  useStore(ClubStore)

  useEffect(async () => {}, [club])

  return (
    <>
      <DataContainer>
        <Row style={{ margin: '10px' }}>
          <H2>Welcome Message</H2>
        </Row>
        <Row style={{ margin: '10px' }}>
          <Text style={{ paddingRight: '25px' }}>Message: </Text>
          <InputContainer>
            <Input
              value={decodeURI(club.customtext?._text)}
              style={{ width: '100%' }}
              fullWidth
              onChange={e => {
                setSelectedClub({ ...club, customtext: { _text: e.target.value } })
              }}
            />
          </InputContainer>
        </Row>
        <Row style={{ margin: '10px' }}>
          <Text style={{ paddingRight: '60px' }}>Link: </Text>
          <InputContainer>
            <Input
              value={
                club.customurl?._text
                  ? club.customurl?._text.replace(/[⁄]/gm, `/`).replace(/&amp;frasl;|&frasl;/g, '/')
                  : ''
              }
              style={{ width: '100%' }}
              fullWidth
              onChange={e => {
                setSelectedClub({ ...club, customurl: { _text: e.target.value } })
              }}
            />
          </InputContainer>
        </Row>
      </DataContainer>
    </>
  )
}
